export default __webpack_public_path__ + "static/media/raystorme.11c899b5.png";